import React, { useContext } from 'react';
import { StateContext } from './StateContainer';
import { TbWorldSearch as WebSiteIcon } from 'react-icons/tb';
import { IoDocumentTextSharp as DocumentIcon } from 'react-icons/io5';
import { MdQuestionAnswer as FaqIcon } from 'react-icons/md';
import { FaPenSquare as FreeTextIcon } from 'react-icons/fa';
import { RiNodeTree as ConversationIcon } from 'react-icons/ri';
import { FaDatabase as DatabaseIcon } from 'react-icons/fa';

const sections = [
  {
    id: '#sitoWeb',
    label: 'Sito Web',
    show: (type) => type !== 'mysql-agent',
    icon: <WebSiteIcon />,
  },
  {
    id: '#documenti',
    label: 'Documenti',
    show: (type) => type !== 'mysql-agent',
    icon: <DocumentIcon />,
  },
  {
    id: '#questionAndAnswers',
    label: 'Q & A',
    show: (type) => type !== 'mysql-agent',
    icon: <FaqIcon />,
  },
  {
    id: '#testoLibero',
    label: 'Testo Libero',
    show: (type) => type !== 'mysql-agent',
    icon: <FreeTextIcon />,
  },
  {
    id: '#nodiConversazione',
    label: 'Conversazione',
    show: (type) => type === 'conversational',
    icon: <ConversationIcon />,
  },
  {
    id: '#database',
    label: 'Database',
    show: (type) => ['conversational', 'mysql-agent'].includes(type),
    icon: <DatabaseIcon />,
  },
];

const NavbarUploadContent = ({ dettagliProgetto }) => {
  const { cambiaSezioneNavbar, setCambiaSezioneNavbar } =
    useContext(StateContext);
  const type = dettagliProgetto[0]?.type || '';

  return (
    <nav
      className="upload-content-navbar-upload move-navbar-upload-content"
      id="navbarUploadContent"
    >
      <div className="upload-content-navbar-upload-inner">
        {sections
          .filter((section) => section.show(type))
          .map(({ id, label, icon }) => (
            <a
              key={id}
              href={id}
              className={`upload-content-navbar-link text-center ${
                cambiaSezioneNavbar === id
                  ? 'upload-content-navbar-link-active'
                  : ''
              }`}
              onClick={() => setCambiaSezioneNavbar(id)}
            >
              <p className="font-size-22">{icon}</p>
              <p className="font-size-10">{label}</p>
            </a>
          ))}
      </div>
    </nav>
  );
};

export default NavbarUploadContent;
